import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PhysicalContactDetails } from 'src/Components/Contacts/PhysicalContactDetails';
import { BlockedContactDeletionModal } from 'src/Components/Modals/BlockedContactDeletionModal';
import { useDeleteContact } from 'src/Hooks/Mutations/useDeleteContact';
import { useToggleFavorite } from 'src/Hooks/Mutations/useToggleFavorite';
import useFetchContact from 'src/Hooks/Queries/useFetchContact';
import { useFetchContactDeletionCheck } from 'src/Hooks/Queries/useFetchContactDeletionCheck';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import { Props } from './PrivatePhysicalContactDetails.types';

const PrivatePhysicalContactDetails = ({ contactId, onClose }: Props) => {
  const { data: contact } = useFetchContact(contactId);
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();

  const [deletionRequestedFor, setDeletionRequestedFor] = useState<string | null>(null);
  const { data: deletionCheck } = useFetchContactDeletionCheck(deletionRequestedFor);

  const { mutate: toggleFavorite } = useToggleFavorite();
  const { mutate: deleteContact } = useDeleteContact({
    onMutate: () => onClose(),
  });

  const requestDelete = (id: string) => {
    setDeletionRequestedFor(id);
  };

  useEffect(() => {
    if (deletionRequestedFor && deletionCheck?.canDelete === true) {
      deleteContact(deletionRequestedFor);
      setDeletionRequestedFor(null);
    }
  }, [deletionRequestedFor, deletionCheck?.canDelete, deleteContact]);

  return (
    <>
      {contact && (
        <PhysicalContactDetails
          contact={contact}
          deleteContact={requestDelete}
          toggleFavorite={toggleFavorite}
          editContact={() => navigate('edit', { state: { disableAnimation: true }, replace: true })}
        />
      )}
      <BlockedContactDeletionModal
        open={!!deletionRequestedFor && deletionCheck?.canDelete === false}
        onClose={() => setDeletionRequestedFor(null)}
        contactName={contact?.displayName ?? ''}
        blockers={deletionCheck?.blockers ?? []}
        assetId={assetId ?? ''}
      />
    </>
  );
};

export default PrivatePhysicalContactDetails;
